<template>
  <div class="pointSet">
    <v-card class="cardWrap">
      <CardTitle title="ポイント一括登録" />
        <PointBulkSearchBox
            :admin="admin"
            :btn="btn"
            :searchWord="search"
            @event="getMemberList"></PointBulkSearchBox>
          <v-container fluid>
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-data-table
                        :headers="headers"
                        :items="desserts"
                        hide-default-footer
                        fixed-header="true"
                        show-select
                        item-key="member_no"
                        v-model="selected"
                        disable-pagination
                        ></v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    align="end"
                    class="pr-12 subtitle-1"
                >
                    総件数 {{ count }}
                </v-col>
            </v-row>
        </v-container>
      <PointBulkRegistBox
        :admin="admin"
        :btn="btn"
        :registData="from_set_data"
        @event="addOverlay = !addOverlay"
        :GolfCourses="golfSelect"
        :pointType="limited_point"
        :receivedSelected="selected"
        ref="Modal"></PointBulkRegistBox>
    </v-card>
    <v-overlay :value="addOverlay">
        <v-card light width="500px">
            <v-card-title v-if="result === ''">ポイント一括登録追加の最終確認</v-card-title>
            <v-card-title v-if="result !== ''">ポイント一括登録追加</v-card-title>
            <v-card-text v-if="result === ''">ポイント一括登録を追加します。</v-card-text>
            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="result === ''" color="primary" text @click="addOverlay = !addOverlay">キャンセル</v-btn>
                <v-btn v-if="result === ''" color="primary" text @click="registPointList">追加</v-btn>
                <v-btn v-if="result !== ''" color="primary" text @click="Initialize">閉じる</v-btn>
            </v-card-actions>
        </v-card>
    </v-overlay>
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
// コンポーネント
import PointBulkSearchBox from './components/PointBulkSearchBox';
import PointBulkRegistBox from './components/PointBulkRegistBox';
// mixins
import { utilityMixin } from '@/mixins/utility';
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';
import { codeListMixin } from '@/mixins/codeList';
import { InputPagesMixin } from '@/views/Master/page/mixin/InputPagesMixin';
// graghql
import { GET_MEMBER_LIST_FROM_POINT_BULK_REGIST } from '@/constants/member';
import { POINT_BULK_REGIST_FROM_GRANT_POINT_LIST } from '@/constants/point_register';

export default {
    components: {
        CardTitle,
        PointBulkSearchBox,
        PointBulkRegistBox
    },
    mixins: [
        utilityMixin,
        authorityMixin,
        golfCourseMixin,
        codeListMixin,
        InputPagesMixin
    ],
    data () {
        return {
            count: 0,
            selected: [],
            adminData: {},
            search: {
                gender: '2',
                birthdayFrom: '',
                birthdayTo: '',
                registdayFrom: '',
                registdayTo: ''
            },
            from_set_data: {
                point_flag: '1',
                point: '',
                grant_date: '',
                validFrom: '',
                validTo: '',
                detail: '',
                comment: '',
                golf_courses_val: ''
            },
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            result: '',
            resultText: '',
            processing: false,
            golf_group_code: process.env.VUE_APP_GROUP_CODE,
            headers: [
                { text: '氏名', value: 'full_name', sortable: false, width: 250 },
                { text: '性別', value: 'gender', sortable: false, width: 100 },
                { text: '誕生日', value: 'birth_date', sortable: false, width: 200 },
                { text: '登録日', value: 'created_at', sortable: false, width: 100 },
                { text: '', value: '' }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '登録', isActive: true }
            ],
            vue_id: 'SCR0011',
            desserts: [],
            golfSelect: [],
            limited_point: []
        };
    },
    async created () {
        this.admin = await this.getLoginAdmin();
        this.golfSelect = this.getGolfCourseList();
        this.limited_point = this.getCodeList('point_flag');
        const today = new Date();
        // 前日に設定
        today.setDate(today.getDate() - 1);
        const y = today.getFullYear();
        let m = today.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        let d = today.getDate();
        d = d < 10 ? '0' + d : d;
        this.from_set_data.grant_date = y + '-' + m + '-' + d;
        this.getAuthorityList();
        this.getMemberList();
    },
    methods: {
        /** ----------------------------------------------
        * 初期表示時処理
        * ---------------------------------------------- */
        Initialize () {
            this.valid = true;
            this.lazy = false;
            this.addOverlay = false;
            this.search = {
                gender: '2',
                birthdayFrom: '',
                birthdayTo: '',
                registdayFrom: '',
                registdayTo: ''
            };
            this.from_set_data.point_flag = '1';
            this.from_set_data.point = '';
            const today = new Date();
            const y = today.getFullYear();
            let m = today.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = today.getDate();
            d = d < 10 ? '0' + d : d;
            this.from_set_data.grant_date = y + '-' + m + '-' + d;
            this.from_set_data.validFrom = '';
            this.from_set_data.validTo = '';
            this.from_set_data.detail = '';
            this.from_set_data.comment = '';
            this.from_set_data.point = '';
            this.from_set_data.golf_courses_val = '';
            this.selected = [];
            this.result = '';
            this.resultText = '';
            this.processing = '';
            this.resetValid();
        },
        /** --------------------------------------------
        * 会員一覧を取得
        * -------------------------------------------- */
        getMemberList () {
            this.$apollo.mutate({
                mutation: GET_MEMBER_LIST_FROM_POINT_BULK_REGIST,
                variables: {
                    gender: parseInt(this.search.gender),
                    birthdateFrom: this.search.birthdayFrom,
                    birthdateTo: this.search.birthdayTo,
                    registdateFrom: this.search.registdayFrom,
                    registdateTo: this.search.registdayTo
                }
            }).then(res => {
                this.count = res.data.getMemberListFromPointBulkRegist.count;
                this.desserts = res.data.getMemberListFromPointBulkRegist.MemberList;
                this.desserts.forEach(el => {
                    el.full_name = el.family_name + ' ' + el.given_name;
                    el.gender = el.gender === 0 ? '男性' : '女性';
                });
            });
        },
        resetValid () {
            this.$refs.Modal.ValidReset();
        },
        /** --------------------------------------------
        * ポイント一括登録を取得
        * -------------------------------------------- */
        registPointList () {
            let data = [];
            this.selected.forEach(el => {
                let obj = {
                    point_flag: parseInt(this.from_set_data.point_flag),
                    point: parseInt(this.from_set_data.point),
                    valid_start: this.from_set_data.validFrom,
                    valid_date: this.from_set_data.validTo,
                    grant_date: this.from_set_data.grant_date,
                    action: this.from_set_data.detail,
                    comment: this.from_set_data.comment,
                    member_no: this.golf_group_code + el.member_no.padStart(8, 0),
                    golf_code: this.from_set_data.golf_courses_val
                };
                data.push(obj);
            });
            // 二重送信防止処理
            if (this.processing) return;
            this.processing = true;

            this.$apollo.mutate({
                mutation: POINT_BULK_REGIST_FROM_GRANT_POINT_LIST,
                variables: {
                    pointList: data
                }
            }).then(res => {
                this.result = res.data.grantPointAdmin.result;
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.add');
                } else if (this.result === 0) {
                    this.resultText = this.$t('result.error.add');
                }
            }).catch(err => {
                this.resultText = this.$t('result.error.add');
                this.error = err;
                this.result = '';
            });
        },
        /** ----------------------------------------------
         * str形式の日付データをdate形式に変換する処理
         * @argument data 変更するstr形式の日付データ
         * ---------------------------------------------- */
        DateTypeChange (data) {
            const getData = new Date(data);
            getData.setDate(getData.getDate() + 1);
            const postData = getData.toISOString().substr(0, 10);
            return postData;
        },
        /** ----------------------------------------------
         * 設定変更ボタン押下時にモーダル画面を開く
         * @argument val モーダル画面の制御値
         * @argument item 設定変更するデータ
         * @const itemStartDate 設定されている倍率適用開始日
         * @const itemEndDate 設定されている倍率適用終了日
         * @const ChangeItem モーダル画面に渡す設定データ
         * ---------------------------------------------- */
        SettingValChange (val, item) {
            this.$refs.PointSettingModal.PointChangeModal(val, item.id);
        },
        /** ----------------------------------------------
         * 新規でポイントを追加する際にモーダル画面を開く
         * @argument val モーダル画面の制御値
         * @const defaultItem モーダル画面に渡す初期値
         * ---------------------------------------------- */
        PointAddSetting: function (val) {
            const defaultItem = {
                point_power: '0',
                start_date: new Date().toISOString().substr(0, 10),
                end_date: '',
                status: ''
            };
            this.$refs.PointSettingModal.PointSettingModal(val, defaultItem);
        }
    }
};
</script>

<style scoped>

.v-data-table{
    overflow: hidden;
    overflow-y: scroll;
    display: block;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    min-height: 200px;
    max-height: 450px;
    width: 100%;
}

.container{
    padding: 0;
}
</style>
